import { Grid, Typography } from "@mui/material";
import { BooleanInput, NumberInput, TextInput, useTranslate } from "react-admin";
import { useWatch } from "react-hook-form";

export default function GeneralFields() {
  const translate = useTranslate();
  const isDeletionActive = useWatch<{ automated_data_deletion_active: boolean }>({
    name: "automated_data_deletion_active",
  });
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6">{translate("settings.headlines.links")}</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          source="website_url"
          label={translate("settings.website_url.name")}
          helperText={translate("settings.website_url.description")}
        />
      </Grid>
      <Grid item xs={0} md={6} />
      <Grid item xs={12} md={4}>
        <TextInput
          source="logo_path"
          label={translate("settings.logo_path.name")}
          helperText={translate("settings.logo_path.description")}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          source="favicon_url"
          label={translate("settings.favicon_url.name")}
          helperText={translate("settings.favicon_url.description")}
        />
      </Grid>
      <Grid item xs={0} md={4} />
      <Grid item xs={12} md={4}>
        <TextInput
          source="imprint_url"
          label={translate("settings.imprint_url.name")}
          helperText={translate("settings.imprint_url.description")}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          source="data_privacy_url"
          label={translate("settings.data_privacy_url.name")}
          helperText={translate("settings.data_privacy_url.description")}
        />
      </Grid>
      <Grid item xs={0} md={4} />
      <Grid item xs={12} md={4}>
        <TextInput
          source="frontend_event_base_path"
          label={translate("settings.frontend_event_base_path.name")}
          helperText={translate("settings.frontend_event_base_path.description")}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          source="frontend_event_path_segment"
          label={translate("settings.frontend_event_path_segment.name")}
          helperText={translate("settings.frontend_event_path_segment.description")}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">{translate("settings.headlines.emailing")}</Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <BooleanInput
          source="read_emails_independent_of_sender"
          label={translate("settings.read_emails_independent_of_sender.name")}
          helperText={translate("settings.read_emails_independent_of_sender.description")}
        />
      </Grid>
      <Grid item xs={12} md={6} />
      <Grid item xs={12} md={4}>
        <TextInput
          source="default_bcc"
          label={translate("settings.default_bcc.name")}
          helperText={translate("settings.default_bcc.description")}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">{translate("settings.headlines.data_deletion")}</Typography>
      </Grid>
      <Grid item xs={12}>
        <BooleanInput
          source="automated_data_deletion_active"
          label={translate("settings.automated_data_deletion_active.name")}
          helperText={translate("settings.automated_data_deletion_active.description")}
        />
      </Grid>
      {isDeletionActive && (
        <>
          <Grid item xs={12} md={4}>
            <NumberInput
              source="automated_data_deletion_user_threshold_days"
              label={translate("settings.automated_data_deletion_user_threshold_days.name")}
              helperText={translate("settings.automated_data_deletion_user_threshold_days.description")}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <NumberInput
              source="automated_data_deletion_invoice_threshold_days"
              label={translate("settings.automated_data_deletion_invoice_threshold_days.name")}
              helperText={translate("settings.automated_data_deletion_invoice_threshold_days.description")}
            />
          </Grid>
        </>
      )}
    </>
  );
}
